import React, { useState, useEffect, useContext, useCallback } from "react";
import { Link } from "react-router-dom";
import { motion, supportsPartialKeyframes } from "framer-motion";
import config from "../../config/config";
import styles from "./Home.module.css";
import styles2 from "../News/News.module.css";
import { TeamService } from "../../services/team_service";
import { HomeService } from "../../services/home_service";
import { NewsService } from "../../services/news_service";
import { PointsTableService } from "../../services/point_table_service";
import { MatchService } from "../../services/match_service";
import { LeagueService } from "../../services/league_service";
import { SponsorService } from "../../services/sponsor_service";
import { SponsorAdvertisementService } from "../../services/sponsor_advertisement_service";
import Subscription from "../Subscription/Subscription";
import MatchesAPI from "../../data/matches";
import ResultAPI from "../../data/result";
import { LeagueCommitteeMemberService } from "../../services/league_committee_member_service";
import { WinningTeamService } from "../../services/winning_team_service";
import { ManOfTheMatchService } from "../../services/man_of_the_match_service";
import { UmpireDetailService } from "../../services/umpire_detail_service";
import { AboutLeagueService } from "../../services/about_league_service";
import { HomeVideoService } from "../../services/home_video_service";
import { GlobalContext } from "../../constants/Context";
import {
  FaTrophy,
  FaUsers,
  FaBroadcastTower,
  FaShieldAlt,
  FaBullseye,
  FaEye,
  FaGem,
  FaHeart,
  FaHome,
  FaUserFriends,
  FaCalendarAlt,
  FaClock,
  FaMapMarkerAlt,
  FaSyncAlt,
  FaPlay,
  FaInfoCircle,
  FaArrowRight,
  FaBullhorn,
  FaNewspaper,
  FaHandshake,
  FaUserTie,
  FaChevronLeft,
  FaChevronRight,
  FaMedal,
  FaAward,
  FaUserCheck,
  FaStar,
  FaFire,
  FaUserSecret,
  FaBuilding,

} from "react-icons/fa";
import { MdSportsCricket } from "react-icons/md";
import Umpire from "./umpire.png"
import AboutLeague from "./trophy.png"
import homeBanner from "./homeBanner.jpg"

import { useHomeState } from "../../states/useHomeState";

function getYouTubeEmbedSrc(url) {
  if (!url || typeof url !== "string") return null;
  let videoId = null;
  try {
    const trimmed = url.trim();
    const withScheme = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
    const u = new URL(withScheme);
    const host = u.hostname.replace(/^www\./, "");
    if (host === "youtu.be") {
      videoId = u.pathname.split("/").filter(Boolean)[0] || null;
    } else if (host.includes("youtube.com")) {
      videoId = u.searchParams.get("v");
      if (!videoId) {
        const parts = u.pathname.split("/").filter(Boolean);
        const embedI = parts.indexOf("embed");
        if (embedI >= 0 && parts[embedI + 1]) videoId = parts[embedI + 1];
        if (!videoId) {
          const shortsI = parts.indexOf("shorts");
          if (shortsI >= 0 && parts[shortsI + 1]) videoId = parts[shortsI + 1];
        }
      }
    }
  } catch {
    return null;
  }
  if (!videoId) return null;
  const id = videoId.split(/[?&#]/)[0];
  if (!id) return null;
  return `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=1&modestbranding=1&rel=0`;
}

const Home = () => {
  const homeService = HomeService();
  const newsService = NewsService();
  const teamService = TeamService();
  const matchService = MatchService();
  const leagueService = LeagueService();
  const aboutLeagueService = AboutLeagueService();
  const sponsorService = SponsorService();
  const sponsorAdvertisementService = SponsorAdvertisementService();
  const pointsTableService = PointsTableService();
  const leagueCommitteeMemberService = LeagueCommitteeMemberService();
  const winningTeamService = WinningTeamService();
  const manOfTheMatchService = ManOfTheMatchService();
  const umpireDetailService = UmpireDetailService();
  const homeVideoService = HomeVideoService();
  const {
    matches, setMatches, currentLiveMatchIndex, setCurrentLiveMatchIndex, matchesLoading, setMatchesLoading, newsData, setNewsData, homeData, setHomeData, sponsorData, setSponsorData, sponsorAds, setSponsorAds, featuredMatches, setFeaturedMatches, pointsTableData, setPointsTableData, foundLeague, setFoundLeague, teams, setTeams, loading, setLoading, activeTab, setActiveTab, currentAdIndex, setCurrentAdIndex, liveResults, setLiveResults, liveResultsLoading, setLiveResultsLoading, leagueCommitteeMembers, setLeagueCommitteeMembers, winningTeams, setWinningTeams, manOfTheMatchList, setManOfTheMatchList, umpireDetails, setUmpireDetails, aboutLeagueDetails, setAboutLeagueDetails, homeVideo, setHomeVideo
  } = useHomeState();
  const currentYear = new Date().getFullYear().toString();
  const [season, setSeason] = useState(currentYear);
  const { SITE_ID } = useContext(GlobalContext);
  const LEAGUE_ID = SITE_ID;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        await homeService.fetchAllHomeData(setHomeData, setSponsorData, setSponsorAds, setLeagueCommitteeMembers, setWinningTeams, setManOfTheMatchList, setUmpireDetails, setAboutLeagueDetails);
        await homeVideoService.fetchHomeVideo(setHomeVideo);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchHomeData();
  }, []);

  useEffect(() => {
    console.log("league comitee memebers leagueCommitteeMembers", leagueCommitteeMembers)
  }, [leagueCommitteeMembers])
  useEffect(() => {
    const fetchNewsData = async () => {
      try {
        await newsService.fetchAllNews(setNewsData);
        await pointsTableService.fetchPointsTable(setPointsTableData);
      } catch (error) {
        console.error("Error fetching news data", error);
        setNewsData([]);
      } finally {
        setLoading(false);
      }
    };
    fetchNewsData();
  }, []);

  const isMatchLive = useCallback((matchDate, matchTime, originalStatus) => {
    const matchStatus = (originalStatus || "").toLowerCase();

    // If API explicitly says it's live
    if (matchStatus.includes("live") || matchStatus.includes("in progress")) {
      return true;
    }

    try {
      // Parse match date and time
      const [day, month, year] = matchDate.split("/");
      const [hours, minutes] = (matchTime || "12:00").split(":");

      // Create match datetime object
      const matchDateTime = new Date(
        year,
        month - 1,
        day,
        parseInt(hours),
        parseInt(minutes)
      );
      const now = new Date();

      const matchEndTime = new Date(
        matchDateTime.getTime() + 8 * 60 * 60 * 1000
      );

      return now >= matchDateTime && now <= matchEndTime;
    } catch (error) {
      console.error("Error checking if match is live:", error);
      return false;
    }
  }, []);

  const determineMatchStatus = useCallback(
    (matchDate, originalStatus) => {
      const matchStatus = (originalStatus || "").toLowerCase();

      if (
        matchStatus.includes("abandoned") ||
        matchStatus.includes("cancelled")
      ) {
        return "cancelled";
      }

      if (matchStatus.includes("live") || matchStatus.includes("in progress")) {
        return "live";
      }

      if (matchStatus.includes("completed") || matchStatus.includes("result")) {
        return "completed";
      }

      try {
        const [day, month, year] = matchDate.split("/");
        const matchDateObj = new Date(year, month - 1, day);
        const today = new Date();

        matchDateObj.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        // Compare dates
        if (matchDateObj < today) {
          return "completed";
        } else if (matchDateObj > today) {
          return "upcoming";
        } else {
          return "live";
        }
      } catch (error) {
        console.error("Error parsing date:", matchDate, error);
        if (season < new Date().getFullYear()) {
          return "completed";
        }
        return "upcoming";
      }
    },
    [season]
  );

  const handleResultsData = useCallback(
    (data) => {

      if (!data || data.length === 0) {
        setLiveResults([]);
        return;
      }

      // Filter for live matches
      const liveMatches = data.filter((result) => {
        // Check if match is live
        return isMatchLive(result.match_date, result.match_time, result.status);
      });

      setLiveResults(liveMatches);
    },
    [isMatchLive]
  );

  const getLiveScore = (matchId) => {
    const result = liveResults.find((r) => r.id === matchId);
    if (!result || !result.innings || result.innings.length === 0) {
      return null;
    }

    // Find which team is currently batting
    const battingInnings = result.innings[result.innings.length - 1];
    const battingTeamId = battingInnings.team_batting_id;

    // Find batting team name
    const battingTeam =
      battingTeamId === result.home_team_id.toString()
        ? { name: result.home_team_name, isHome: true }
        : { name: result.away_team_name, isHome: false };

    return {
      battingTeam: battingTeam.name,
      runs: battingInnings.runs,
      wickets: battingInnings.wickets,
      overs: battingInnings.overs,
      target: result.innings.length === 2 ? result.innings[0].runs : null,
      requiredRuns:
        result.innings.length === 2
          ? result.innings[0].runs - battingInnings.runs + 1
          : null,
      ballsRemaining: battingInnings.balls
        ? parseInt(battingInnings.balls)
        : null,
    };
  };
  const getAllLiveMatches = () => {
    // First get live matches from regular matches data
    const matchesLive = matches.filter((match) => match.status === "live");

    // Combine with results data for live matches
    const combinedLiveMatches = [...matchesLive];

    // Add any live results that aren't already in matches
    liveResults.forEach((result) => {
      if (!combinedLiveMatches.some((match) => match.id === result.id)) {
        const isLive = isMatchLive(
          result.match_date,
          result.match_time,
          result.status
        );
        if (isLive) {
          combinedLiveMatches.push({
            id: result.id,
            competition_id: result.competition_id,
            name: `${result.home_team_name} vs ${result.away_team_name}`,
            status: "live",
            published: result.published,
            last_updated: result.last_updated,
            league_name: result.league_name,
            league_id: result.league_id,
            competition_name: result.competition_name,
            competition_type: result.competition_type,
            match_type: result.match_type,
            game_type: result.game_type,
            season: result.season,
            match_date: result.match_date,
            match_time: result.match_time,
            ground_name: result.ground_name,
            ground_id: result.ground_id,
            home_club_name: result.home_club_name,
            home_team_name: result.home_team_name,
            home_team_id: result.home_team_id,
            home_club_id: result.home_club_id,
            away_club_name: result.away_club_name,
            away_team_name: result.away_team_name,
            away_team_id: result.away_team_id,
            away_club_id: result.away_club_id,
            umpire_1_name: result.umpire_1_name,
            umpire_1_id: result.umpire_1_id,
            umpire_2_name: result.umpire_2_name,
            umpire_2_id: result.umpire_2_id,
            scorer_1_name: result.scorer_1_name,
            scorer_1_id: result.scorer_1_id,
            original_status: result.status,
            hasLiveScore: true,
          });
        }
      }
    });

    // Return ALL live matches (no slice)
    return combinedLiveMatches;
  };

  const getFullImageUrl = (iconPath) => {
    if (!iconPath) return "/default-team.png";
    if (iconPath.startsWith("http")) return iconPath;
    return `${config.baseURL}${iconPath}`;
  };
  // Calculate required run rate helper function
  const calculateRequiredRR = (match) => {
    if (!match || !match.score_team1 || !match.score_team2) return "0.00";

    try {
      const team1Runs = parseInt(match.score_team1.split('/')[0]);
      const team2Runs = parseInt(match.score_team2.split('/')[0]);
      const currentOver = parseFloat(match.current_over) || 0;

      if (currentOver === 0 || team1Runs <= team2Runs) return "0.00";

      const runsNeeded = team1Runs - team2Runs;
      const ballsRemaining = (50 - currentOver) * 6; // Assuming 50 overs match
      const requiredRR = (runsNeeded / ballsRemaining) * 6;

      return requiredRR.toFixed(2);
    } catch (error) {
      return "0.00";
    }
  };
  const getCategoryColor = (category) => {
    const colors = {
      match: "#e74c3c",
      transfer: "#3498db",
      interview: "#9b59b6",
      analysis: "#f39c12",
      announcement: "#2ecc71",
    };
    return colors[category?.toLowerCase()] || "#e74c3c";
  };

  const getContentExcerpt = (content, length = 120) => {
    if (!content) return "No content available...";
    const textContent = content.replace(/<[^>]*>/g, "");
    return textContent.length > length
      ? textContent.substring(0, length) + "..."
      : textContent;
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  };

  const getFilteredMatches = () => {
    const currentDate = new Date();

    switch (activeTab) {
      case "upcoming":
        return featuredMatches.filter((match) => {
          const matchDate = new Date(match.match_date);
          return matchDate > currentDate && match.status !== "Upcoming";
        });

      case "live":
        return featuredMatches.filter(
          (match) => match.status === "live" || match.status === "Live"
        );

      case "completed":
        return featuredMatches.filter(
          (match) =>
            match.status === "completed" || match.status === "Completed"
        );

      default:
        return featuredMatches;
    }
  };

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "live":
        return styles.live;
      case "completed":
        return styles.completed;
      case "upcoming":
        return styles.upcoming;
      default:
        return styles.upcoming;
    }
  };

  const getStatusText = (match) => {
    const status = match.status?.toLowerCase();
    const matchDate = new Date(match.match_date);
    const currentDate = new Date();

    if (status === "live" || status === "completed") {
      return status.charAt(0).toUpperCase() + status.slice(1);
    }

    if (matchDate > currentDate) {
      return "Upcoming";
    }

    return "Upcoming";
  };

  const handleMatchesData = useCallback(
    (data) => {

      if (!data || data.length === 0) {

        setMatches([]);
        setMatchesLoading(false);
        return;
      }

      // Filter matches by league_id
      const leagueMatches = data.filter(
        (match) =>
          match.league_id && match.league_id.toString() === LEAGUE_ID.toString()
      );

      // Transform matches data for display
      const transformedMatches = leagueMatches.map((match) => {
        // Determine match status
        const determineMatchStatus = (matchDate, originalStatus) => {
          const matchStatus = (originalStatus || "").toLowerCase();

          if (
            matchStatus.includes("abandoned") ||
            matchStatus.includes("cancelled")
          ) {
            return "cancelled";
          }
          if (
            matchStatus.includes("live") ||
            matchStatus.includes("in progress")
          ) {
            return "live";
          }
          if (
            matchStatus.includes("completed") ||
            matchStatus.includes("result")
          ) {
            return "completed";
          }

          try {
            const [day, month, year] = matchDate.split("/");
            const matchDateObj = new Date(year, month - 1, day);
            const today = new Date();

            matchDateObj.setHours(0, 0, 0, 0);
            today.setHours(0, 0, 0, 0);

            if (matchDateObj < today) return "completed";
            if (matchDateObj > today) return "upcoming";
            return "live";
          } catch (error) {
            if (season < new Date().getFullYear()) return "completed";
            return "upcoming";
          }
        };

        const status = determineMatchStatus(match.match_date, match.status);

        // Format match date
        const formatMatchDate = (dateString) => {
          if (!dateString) return "Undecided";
          try {
            const [day, month, year] = dateString.split("/");
            const date = new Date(year, month - 1, day);
            return date.toLocaleString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            });
          } catch (e) {
            return dateString;
          }
        };

        // Get team short names
        const getTeamShortName = (teamName) => {
          if (!teamName) return "Undecided";
          const words = teamName.split(" ");
          if (words.length > 1) {
            return words
              .map((word) => word.charAt(0))
              .join("")
              .toUpperCase();
          }
          return teamName.substring(0, 3).toUpperCase();
        };

        // Get full team name
        const getFullTeamName = (clubName, teamName) => {
          if (!clubName) return teamName || "Unknown Team";
          if (!teamName) return clubName;
          return `${clubName} ${teamName}`;
        };

        // Generate random scores for completed matches
        const generateScore = () => {
          const runs = Math.floor(Math.random() * 200) + 150;
          const wickets = Math.floor(Math.random() * 10);
          return `${runs}/${wickets}`;
        };

        return {
          id: match.id,
          match_date: match.match_date,
          formatted_date: formatMatchDate(match.match_date),
          match_time: match.match_time || "12:00",
          status: status,
          venue: match.ground_name || "Undecided",
          team1_data: {
            id: match.home_team_id,
            name: getFullTeamName(match.home_club_name, match.home_team_name),
            short_name: getTeamShortName(
              match.home_club_name || match.home_team_name
            ),
            logo: "/default-team.png",
            club_name: match.home_club_name,
            team_name: match.home_team_name,
          },
          team2_data: {
            id: match.away_team_id,
            name: getFullTeamName(match.away_club_name, match.away_team_name),
            short_name: getTeamShortName(
              match.away_club_name || match.away_team_name
            ),
            logo: "/default-team.png",
            club_name: match.away_club_name,
            team_name: match.away_team_name,
          },
          score_team1: status === "completed" ? generateScore() : "0/0",
          score_team2: status === "completed" ? generateScore() : "0/0",
          league: {
            id: match.league_id || LEAGUE_ID,
            name: match.league_name || "Royal Sports League",
          },
          competition: {
            id: match.competition_id,
            name: match.competition_name || "League",
          },
          is_featured: status === "live",
        };
      });

      // Sort matches: live first, then upcoming, then completed
      const sortedMatches = transformedMatches.sort((a, b) => {
        const statusOrder = {
          live: 0,
          upcoming: 1,
          completed: 2,
          cancelled: 3,
        };
        return statusOrder[a.status] - statusOrder[b.status];
      });

      // Take only first 3 matches for homepage
      const topMatches = sortedMatches.slice(0, 5);

      setMatches(topMatches);
      setMatchesLoading(false);

    },
    [season]
  );

  // Handle API error
  const handleMatchesAPIError = useCallback((errorMsg) => {
    console.error("Matches API Error in Home:", errorMsg);
    setMatches([]);
    setMatchesLoading(false);
  }, []);

  // Handle API loading
  const handleMatchesAPILoading = useCallback((isLoading) => {
    setMatchesLoading(isLoading);
  }, []);

  // Handle results error
  const handleResultsError = useCallback((errorMsg) => {
    console.error("Results API Error:", errorMsg);
    // Don't set main error, just log for live results
  }, []);

  // Handle results loading
  const handleResultsLoading = useCallback((isLoading) => {
    setLiveResultsLoading(isLoading);
  }, []);

  // Handle ad click
  const handleAdClick = (ad) => {
    if (ad.target_url) {
      window.open(ad.target_url, "_blank", "noopener,noreferrer");
    }
  };

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.spinner}></div>
        <p>Loading...</p>
      </div>
    );
  }

  const homeVideoEmbedSrc = homeVideo?.link ? getYouTubeEmbedSrc(homeVideo.link) : null;

  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 60,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  // Get all live matches
  const allLiveMatches = getAllLiveMatches();

  return (
    <div className={styles.homePage}>
      {/* Hero Section */}
      {/* <section className={styles.heroSection}>
        <div className={styles.heroBackground}>
        </div>
        <div className={styles.heroContent}>
          <div className={styles.container}>
            {homeData.season && (
              <div className={styles.heroBadge}>{homeData.season} Season</div>
            )}
            {homeData.banner_title ? (
              <h1 className={styles.heroTitle}>
                <span>{homeData.banner_title}</span>
              </h1>
            ) : (
              <h1 className={styles.heroTitle}>
                <span>Royal Sports League</span>
              </h1>
            )}
            <p className={styles.heroSubtitle} style={{ color: "white" }}>
              {homeData.banner_subtitle}
            </p>
            <p className={styles.p} style={{ color: "white" }}>
              {homeData.highlight_text}
            </p>
            <div className={styles.heroStats}>
              <div className={styles.statItem}>
                <div className={styles.statNumber}>{homeData.elite_teams ? homeData.elite_teams : "0"}</div>
                <div className={styles.statLabel}>Elite Teams</div>
              </div>

              <div className={styles.statItem}>
                <div className={styles.statNumber}>
                  {homeData.total_matches ? homeData.total_matches : "0"}
                </div>
                <div className={styles.statLabel}>Thrilling Matches</div>
              </div>


              <div className={styles.statItem}>
                <div className={styles.statNumber}>{homeData.total_days ? homeData.total_days : "0"}</div>
                <div className={styles.statLabel}>Days of Action</div>
              </div>

            </div>
          </div>
        </div>
      </section> */}

      <section className={styles.heroSection}>
       
          <img
            className={styles.heroVideo}
            src={homeBanner}

          />
        {/* Video Background */}


        {/* Optional overlay for readability */}
        <div className={styles.heroOverlay}></div>

        {/* Hero Content */}
        <div className={styles.heroContent}>
          <div className={styles.container}>
            {homeData.season && (
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                className={styles.heroBadge}
              >
                {homeData.season} Season
              </motion.div>
            )}

            <h1 className={styles.heroTitle}>
              <span>{homeData.banner_title || "Royal Sports League"}</span>
            </h1>

            <p className={styles.heroSubtitle}>
              {homeData.banner_subtitle}
            </p>

            <p className={styles.p}
            style={{color : "#db9f06"}}
           
            >
              {homeData.highlight_text}
            </p>

            <div className={styles.heroStats}>
              <div className={styles.statItem}>
                <div className={styles.statNumber}>
                  {homeData.elite_teams || "0"}
                </div>
                <div className={styles.statLabel}>Elite Teams</div>
              </div>

              <div className={styles.statItem}>
                <div className={styles.statNumber}>
                  {homeData.total_matches || "0"}
                </div>
                <div className={styles.statLabel}>Thrilling Matches</div>
              </div>

              <div className={styles.statItem}>
                <div className={styles.statNumber}>
                  {homeData.total_days || "0"}
                </div>
                <div className={styles.statLabel}>Days of Action</div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* API Components (invisible, handle API calls) */}
      <MatchesAPI
        siteId={SITE_ID}
        season={season}
        onDataLoaded={handleMatchesData}
        onError={handleMatchesAPIError}
        onLoading={handleMatchesAPILoading}
      />

      <ResultAPI
        siteId={SITE_ID}
        season={season}
        onDataLoaded={handleResultsData}
        onError={handleResultsError}
        onLoading={handleResultsLoading}
      />

      {allLiveMatches.length > 0 && (
        <section className={styles.liveScoreSection}>
          <div className={styles.container}>
            <div className={styles.liveScoreHeader}>
              <div className={styles.liveScoreTitle}>
                <span className={styles.liveDot}></span>
                Live Match{allLiveMatches.length > 1 ? 'es' : ''}
              </div>
              {allLiveMatches.length > 1 && (
                <div className={styles.liveMatchesCount}>
                  Match {currentLiveMatchIndex + 1} of {allLiveMatches.length}
                </div>
              )}
            </div>

            <div className={styles.liveScoreContainer}>
              {/* Left Navigation Button - Only show if multiple live matches */}
              {allLiveMatches.length > 1 && (
                <button
                  className={`${styles.liveScoreNav} ${styles.prev}`}
                  onClick={() => setCurrentLiveMatchIndex(prev =>
                    prev === 0 ? allLiveMatches.length - 1 : prev - 1
                  )}
                  aria-label="Previous live match"
                >
                  <FaChevronLeft />
                </button>
              )}

              {/* Live Score Card */}
              <div className={styles.liveScoreCard}>
                {/* Match Header */}
                <div className={styles.liveMatchHeader}>
                  <div className={styles.liveMatchInfo}>
                    <h3 className={styles.liveMatchTitle}>
                      {allLiveMatches[currentLiveMatchIndex]?.competition?.name || "League Match"} • {allLiveMatches[currentLiveMatchIndex]?.match_type || "Cricket"}
                    </h3>
                    <div className={styles.liveMatchMeta}>
                      <span>
                        <FaCalendarAlt /> {formatDate(allLiveMatches[currentLiveMatchIndex]?.match_date) || "Date TBD"}
                      </span>
                      {allLiveMatches[currentLiveMatchIndex]?.match_time && (
                        <span><FaClock /> {allLiveMatches[currentLiveMatchIndex]?.match_time}</span>
                      )}
                      {allLiveMatches[currentLiveMatchIndex]?.venue && (
                        <span><FaMapMarkerAlt /> {allLiveMatches[currentLiveMatchIndex]?.venue}</span>
                      )}
                    </div>
                  </div>
                  <div className={styles.liveMatchStatus}>
                    LIVE
                  </div>
                </div>

                {/* Teams and Score */}
                <div className={styles.liveScoreTeams}>
                  {/* Home Team */}
                  <div className={styles.liveTeam}>
                    <div className={styles.liveTeamHeader}>
                      <div className={styles.liveTeamName}>
                        <h3>{allLiveMatches[currentLiveMatchIndex]?.team1_data?.name || 'TBD'}</h3>
                        <div className={styles.liveTeamClub}>
                          {allLiveMatches[currentLiveMatchIndex]?.team1_data?.club_name || ''}
                        </div>
                      </div>
                      {allLiveMatches[currentLiveMatchIndex]?.status === "live" && allLiveMatches[currentLiveMatchIndex]?.score_team1 && allLiveMatches[currentLiveMatchIndex]?.score_team1 !== "0/0" && (
                        <div className={styles.liveTeamScore}>
                          <span className={styles.liveTeamRuns}>
                            {allLiveMatches[currentLiveMatchIndex]?.score_team1.split('/')[0] || 0}
                          </span>
                          <span className={styles.liveTeamWickets}>
                            /{allLiveMatches[currentLiveMatchIndex]?.score_team1.split('/')[1] || 0}
                          </span>
                          <div className={styles.liveTeamOvers}>
                            ({allLiveMatches[currentLiveMatchIndex]?.current_over || "0.0"} ov)
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Score Details if available */}
                    {allLiveMatches[currentLiveMatchIndex]?.status === "live" && allLiveMatches[currentLiveMatchIndex]?.score_team1 && allLiveMatches[currentLiveMatchIndex]?.score_team1 !== "0/0" && (
                      <div className={styles.liveScoreDetails}>
                        <div className={styles.liveInningsInfo}>
                          <div className={styles.liveInningsItem}>
                            <span className={styles.liveInningsLabel}>Current Run Rate</span>
                            <span className={styles.liveInningsValue}>
                              {allLiveMatches[currentLiveMatchIndex]?.current_run_rate || '0.00'}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* VS Separator */}
                  <div className={styles.liveVSSeparator}>
                    <div className={styles.liveVS}>VS</div>
                  </div>

                  {/* Away Team */}
                  <div className={styles.liveTeam}>
                    <div className={styles.liveTeamHeader}>
                      <div className={styles.liveTeamName}>
                        <h3>{allLiveMatches[currentLiveMatchIndex]?.team2_data?.name || 'TBD'}</h3>
                        <div className={styles.liveTeamClub}>
                          {allLiveMatches[currentLiveMatchIndex]?.team2_data?.club_name || ''}
                        </div>
                      </div>
                      {allLiveMatches[currentLiveMatchIndex]?.status === "live" && allLiveMatches[currentLiveMatchIndex]?.score_team2 && allLiveMatches[currentLiveMatchIndex]?.score_team2 !== "0/0" && (
                        <div className={styles.liveTeamScore}>
                          <span className={styles.liveTeamRuns}>
                            {allLiveMatches[currentLiveMatchIndex]?.score_team2.split('/')[0] || 0}
                          </span>
                          <span className={styles.liveTeamWickets}>
                            /{allLiveMatches[currentLiveMatchIndex]?.score_team2.split('/')[1] || 0}
                          </span>
                          {allLiveMatches[currentLiveMatchIndex]?.current_run_rate && (
                            <div className={styles.liveTeamOvers}>
                              RR: {allLiveMatches[currentLiveMatchIndex]?.current_run_rate}
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    {/* If match has live score data from API */}
                    {allLiveMatches[currentLiveMatchIndex]?.hasLiveScore && (
                      <div className={styles.liveScoreDetails}>
                        <div className={styles.liveInningsInfo}>
                          <div className={styles.liveInningsItem}>
                            <span className={styles.liveInningsLabel}>Required Run Rate</span>
                            <span className={`${styles.liveInningsValue} ${styles.highlight}`}>
                              {calculateRequiredRR(allLiveMatches[currentLiveMatchIndex])}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>


              </div>

              {allLiveMatches.length > 1 && (
                <button
                  className={`${styles.liveScoreNav} ${styles.next}`}
                  onClick={() => setCurrentLiveMatchIndex(prev =>
                    prev === allLiveMatches.length - 1 ? 0 : prev + 1
                  )}
                  aria-label="Next live match"
                >
                  <FaChevronRight />
                </button>
              )}
            </div>
          </div>
        </section>
      )}

      {aboutLeagueDetails.length > 0 && (

        <section className={`${styles.features} ${styles.section}`}>
          <div className={styles.container}>
            <div className={styles.sectionHeader}>
              <h2 className={styles.sectionTitle}>
                Why Choose Royal Sports League?
              </h2>
            </div>
            <div className={styles.featuresGrid}>
              {aboutLeagueDetails.map((aboutleague, index) => (
                <div className={styles.featureItem} key={index}>
                  <div className={styles.featureIcon}>
                    {aboutleague.icon ? (
                      <img src={getFullImageUrl(aboutleague.icon)} alt={aboutleague.title} height={50} />
                    ) : <img src={AboutLeague} alt={aboutleague.title} height={50} />}
                  </div>
                  <h3>{aboutleague.title}</h3>
                  <p>{aboutleague.description}</p>
                </div>
              ))}
            </div>

          </div>
        </section>

      )}

      {homeVideoEmbedSrc && (
        <motion.section
          className={`${styles.liveMatchVideoSection} ${styles.section}`}
          initial="hidden"
          whileInView="visible"
          variants={fadeUp}
          viewport={{ once: true, amount: 0.2 }}
        >
          <div className={styles.container}>
            <div className={styles.sectionHeader}>
              <h2 className={styles.sectionTitle}>Live Match Video</h2>
            </div>
            {homeVideo?.name ? (
              <p className={styles.liveMatchVideoSubtitle}>{homeVideo.name}</p>
            ) : null}
          </div>
          <div className={styles.liveMatchVideoFullBleed}>
            <div className={styles.liveMatchVideoFrame}>
              <iframe
                title={homeVideo?.name || "Live match video"}
                src={homeVideoEmbedSrc}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                loading="lazy"
              />
            </div>
          </div>
        </motion.section>
      )}

      {/* Featured Matches Section */}
      <section
        id="fixtures"
        className={`${styles.featuredMatchesSection} ${styles.section}`}
      >
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>Match Schedule</h2>
            <Link to="/cricket-matches" className={styles.viewAll}>
              View All <FaArrowRight />
            </Link>
          </div>

          {matchesLoading ? (
            <div className={styles.loadingContainer}>
              <div className={styles.spinner}></div>
              <p>Loading matches...</p>
            </div>
          ) : matches.length === 0 ? (
            <div className={styles.noMatches}>
              <div className={styles.noMatchesIcon}>  <MdSportsCricket /></div>
              <h3>No matches found for {season} season</h3>
              <p>Try selecting a different season</p>

            </div>
          ) : (
            <div className={styles.groupedMatches}>
              {(() => {
                const groupedMatchesByDate = (matchesList) => {
                  const grouped = {};

                  matchesList.forEach(match => {
                    const getFullFormattedDate = (dateString) => {
                      if (!dateString) return "Unknown Date";
                      const [day, month, year] = dateString.split('/');
                      const date = new Date(year, month - 1, day);
                      return date.toLocaleDateString('en-US', {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      });
                    };

                    const dateStr = getFullFormattedDate(match.match_date);
                    if (!grouped[dateStr]) grouped[dateStr] = [];
                    grouped[dateStr].push(match);
                  });

                  return grouped;
                };

                const limitedMatches = matches.slice(0, 3);
                const grouped = groupedMatchesByDate(limitedMatches);
                const dates = Object.keys(grouped);


                return dates.map(date => (
                  <div key={date} className={styles.dateCategory}>
                    <div className={styles.categoryMatches}>
                      {grouped[date].map((match, index) => {
                        const formatMatchDate = (dateString) => {
                          if (!dateString) return "N/A";
                          try {
                            const [day, month, year] = dateString.split('/');
                            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                            return `${day} ${months[parseInt(month) - 1]} ${year}`;
                          } catch (err) {
                            return dateString;
                          }
                        };

                        const getMatchStatus = (match) => {
                          if (match.status === "live") return "Live";
                          if (match.status === "completed") return "Completed";
                          if (match.status === "cancelled") return "Cancelled";
                          return "Upcoming";
                        };

                        const getStatusClass = (status) => {
                          switch (status) {
                            case "live":
                              return styles.live;
                            case "completed":
                              return styles.completed;
                            case "cancelled":
                              return styles.cancelled;
                            default:
                              return styles.upcoming;
                          }
                        };

                        const matchStatus = getMatchStatus(match);
                        const statusClass = getStatusClass(match.status);

                        return (
                          <div key={match.id} className={`${styles.matchCard} ${styles.upcomingMatch}`}>
                            <div className={styles.matchHeader}>
                              <div className={styles.matchDateContainer}>
                                <FaCalendarAlt />
                                <span className={styles.matchDate}>
                                  {formatMatchDate(match.match_date)}
                                </span>
                                {match.match_time && match.match_time !== "12:00" && (
                                  <span className={styles.matchTime}>
                                    | {match.match_time}
                                  </span>
                                )}
                              </div>
                              <div className={styles.matchFormat}>
                                <FaClock />
                                <span>{match.match_type || "Cricket"}</span>
                              </div>
                            </div>

                            <div className={styles.teamsContainer}>
                              {/* Home Team */}
                              <div className={styles.teamRow}>
                                <div className={styles.teamInfo}>
                                  <div className={styles.teamNameWrapper}>
                                    <span className={styles.teamName}>
                                      {match.team1_data?.name}
                                    </span>
                                    <span className={styles.homeBadge}>
                                      <FaHome />
                                    </span>
                                  </div>
                                  <span className={styles.teamRole}>
                                    Home Team
                                  </span>
                                </div>
                                {match.status === "completed" && match.score_team1 && match.score_team1 !== "0/0" && (
                                  <div className={styles.scoreInfo}>
                                    <span className={styles.score}>
                                      {match.score_team1}
                                    </span>
                                    {match.current_over && match.current_over !== "0.0" && (
                                      <span className={styles.overs}>
                                        ({match.current_over} ov)
                                      </span>
                                    )}
                                  </div>
                                )}
                              </div>

                              <div className={styles.vsSeparator}>
                                <span className={styles.vsSpan}>VS</span>
                              </div>

                              {/* Away Team */}
                              <div className={styles.teamRow}>
                                <div className={styles.teamInfo}>
                                  <div className={styles.teamNameWrapper}>
                                    <span className={styles.teamName}>
                                      {match.team2_data?.name}
                                    </span>
                                    <span className={styles.awayBadge}>
                                      <FaUserFriends />
                                    </span>
                                  </div>
                                  <span className={styles.teamRole}>
                                    Away Team
                                  </span>
                                </div>
                                {match.status === "completed" && match.score_team2 && match.score_team2 !== "0/0" && (
                                  <div className={styles.scoreInfo}>
                                    <span className={styles.score}>
                                      {match.score_team2}
                                    </span>
                                    {match.current_run_rate && match.current_run_rate !== "0.00" && (
                                      <span className={styles.runRate}>
                                        RR: {match.current_run_rate}
                                      </span>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className={styles.matchFooter}>
                              <div className={styles.matchDetails} style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <div className={styles.competitionInfo}>
                                  <FaTrophy />
                                  <span>{match.competition?.name || "League"}</span>
                                </div>
                                {match.status === "completed" && (
                                  <div className={styles.matchActions}>
                                    <Link
                                      to={`/cricket-match/${match.id}`}
                                      className={styles.matchButton}
                                    >
                                      View Result
                                    </Link>
                                  </div>
                                )}
                                <div className={`${styles.matchStatusBadge} ${statusClass}`}>
                                  <span>
                                    {match.status === "live" ? "Live Now" :
                                      match.status === "completed" ? "Completed" :
                                        match.status === "cancelled" ? "Cancelled" : "Upcoming"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ));
              })()}
            </div>
          )}
        </div>
      </section>


      {leagueCommitteeMembers.length > 0 && (
        <section className={`${styles.MembersSection} ${styles.section}`}>
          <div className={styles.container}>
            <div className={styles.sectionHeader}>
              <h2 className={styles.sectionTitle}>League Committee Members</h2>
            </div>
            <marquee
              behavior="scroll"
              direction="left"
              scrollamount="8"
              onMouseOver={(e) => e.currentTarget.stop()}
              onMouseOut={(e) => e.currentTarget.start()}
            >
              <div className={styles.marqueeInner}>
                {leagueCommitteeMembers.map((member, index) => (
                  <img
                    key={index}
                    src={getFullImageUrl(member.image)}
                    alt={member.name}
                    className={styles.marqueeImgLarge}
                    onError={(e) => (e.target.src = "/default-member.png")}
                  />
                ))}
              </div>
            </marquee>
          </div>
        </section>
      )}


      {winningTeams.length > 0 && (
        <section className={`${styles.WinTeamSection} ${styles.section}`}>
          <div className={styles.container}>
            <div className={styles.sectionHeader}>
              <h2 className={styles.sectionTitle}>Winning Teams</h2>
            </div>
            <marquee
              behavior="scroll"
              direction="left"
              scrollamount="8"
              onMouseOver={(e) => e.currentTarget.stop()}
              onMouseOut={(e) => e.currentTarget.start()}
            >
              <div className={styles.marqueeInner}>
                {winningTeams.map((team, index) => (
                  <img
                    key={index}
                    src={getFullImageUrl(team.image)}
                    alt={team.name}
                    className={styles.marqueeImgMedium}
                    onError={(e) => (e.target.src = "/default-team.png")}
                  />
                ))}
              </div>
            </marquee>
          </div>
        </section>
      )}


      {(() => {
        // Check if there are any Man of the Match awards
        if (!manOfTheMatchList || manOfTheMatchList.length === 0) {
          return null;
        }

        // Get current date and date 7 days ago
        const currentDate = new Date();
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(currentDate.getDate() - 7);

        // Filter awards from last 7 days only
        const recentAwards = manOfTheMatchList.filter(award => {
          try {
            if (!award.created_at) return false;
            const awardDate = new Date(award.created_at);
            return awardDate >= sevenDaysAgo && awardDate <= currentDate;
          } catch (error) {
            return false;
          }
        });

        // If no recent awards, don't render the section
        if (recentAwards.length === 0) {
          return null;
        }

        // Format date function
        const formatDisplayDate = (dateString) => {
          if (!dateString) return "";
          try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
              day: 'numeric',
              month: 'short',
              year: 'numeric'
            });
          } catch (error) {
            return dateString;
          }
        };

        return (
          <motion.section
            className={`${styles.ManOfTheMatchSection} ${styles.section}`}
            initial="hidden"
            whileInView="visible"
            variants={fadeUp}
            viewport={{ once: true, amount: 0.3 }}
          >
            <div className={styles.container}>
              <div className={styles.sectionHeader}>
                <h2 className={styles.sectionTitle}>Man Of The Match</h2>
                <Link to="/man-of-the-match" className={styles.viewAll}>
                  View All →
                </Link>
              </div>

              <marquee
                behavior="scroll"
                direction="left"
                scrollamount="8"
                onMouseOver={(e) => e.currentTarget.stop()}
                onMouseOut={(e) => e.currentTarget.start()}
              >
                <div style={{ display: "flex", gap: "10px" }}>
                  {manOfTheMatchList.map((player, index) => (
                    <div
                      key={`${player.id || index}`}
                      className={styles.motmSlide}
                      style={{ flex: "0 0 auto" }}
                    >
                      <div className={styles.motmCard}>
                        <div className={styles.motmImageWrapper}>
                          <img
                            src={getFullImageUrl(player.image)}
                            alt={player.player_name || player.name}
                            className={styles.motmImage}
                            onError={(e) => {
                              e.target.src = "/default-player.png";
                              e.target.onerror = null;
                            }}
                          />
                          <div className={styles.trophyBadge}>
                            <FaTrophy />
                          </div>
                        </div>

                        <div className={styles.motmContent}>
                          <h3 className={styles.motmName}>
                            {player.player_name || player.name}
                          </h3>

                          {player.match_date && (
                            <div className={styles.motmDate}>
                              <FaCalendarAlt />
                              <span>{formatDisplayDate(player.match_date)}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </marquee>
            </div>
          </motion.section>
        );
      })()}

      {umpireDetails.length > 0 && (
        <motion.section
          className={`${styles.UmpireDetailsSection} ${styles.section}`}
          initial="hidden"
          whileInView="visible"
          variants={fadeUp}
          viewport={{ once: true, amount: 0.3 }}
        >
          <div className={styles.container}>
            <div className={styles.sectionHeader}>
              <h2 className={styles.sectionTitle}>Our Umpires</h2>
            </div>

            <marquee
              behavior="scroll"
              direction="left"
              scrollamount="6"
              onMouseOver={(e) => e.currentTarget.stop()}
              onMouseOut={(e) => e.currentTarget.start()}
            >
              <div style={{
                display: "flex",
                gap: "30px",
                width: "max-content",
                alignItems: "stretch"
              }}>
                {umpireDetails.map((umpire, index) => (
                  <div
                    key={`${umpire.id || index}-${Math.random()}`}
                    className={styles.umpireSlide}
                    style={{ flex: "0 0 320px", height: "auto" }}
                  >
                    <div className={styles.umpireCard} style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                      <div className={styles.umpireImageWrapper}>
                        {umpire.image ? (
                          <img
                            src={getFullImageUrl(umpire.image)}
                            alt={umpire.name}
                            className={styles.umpireImage}
                            onError={(e) => {
                              e.target.src = { Umpire };
                            }}
                          />
                        ) : (<img
                          src={Umpire}
                          alt={umpire.name}
                          className={styles.umpireImage}
                          onError={(e) => {
                            e.target.src = { Umpire };
                          }}
                        />)}

                      </div>

                      <div className={styles.umpireContent}>
                        <h3 className={styles.umpireName}>{umpire.name}</h3>

                        <p
                          className={styles.umpireDetail}

                        >
                          {umpire.detail}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </marquee>
          </div>
        </motion.section>
      )}
      {
        newsData.length > 0 && (
          <section className={`${styles.newsSection} ${styles.section}`}>
            <div className={styles.container}>
              <div className={styles.sectionHeader}>
                <h2 className={styles.sectionTitle}>Latest News</h2>
                <Link to="/news" className={styles.viewAll}>
                  View All →
                </Link>
              </div>

              <div className={styles2.container}>
                {newsData.length === 0 ? (
                  <div className={styles2.noNews}>
                    <div className={styles2.noNewsIcon}>  <FaNewspaper /></div>
                    <h3>No News Found</h3>
                  </div>
                ) : (
                  <div className={styles2.newsGrid}>
                    {newsData.slice(0, 3).map((news, index) => (
                      <article
                        key={news.id || index}
                        className={styles2.newsCard}
                        style={{ animationDelay: `${index * 0.1}s` }}
                      >
                        <div className={styles2.newsImage}>
                          <img
                            src={getFullImageUrl(news.image)}
                            alt={news.title || "News Image"}
                            className={styles2.image}
                            onError={(e) => {
                              e.target.src = "/default-news.jpg";
                            }}
                          />
                          <div
                            className={styles2.newsCategory}
                            style={{
                              backgroundColor: getCategoryColor(news.category),
                            }}
                          >
                            {news.category || "News"}
                          </div>
                          {news.is_featured && (
                            <div className={styles2.featuredBadge}><FaStar /> Featured</div>
                          )}
                        </div>

                        <div className={styles2.newsContent}>
                          <div className={styles2.newsMeta}>
                            <span className={styles2.newsDate}>
                              {formatDate(news.published_at)}
                            </span>
                            {news.author && (
                              <span className={styles2.newsAuthor}>
                                By {news.author}
                              </span>
                            )}
                          </div>

                          <h3 className={styles2.newsTitle}>
                            {news.title}
                          </h3>
                          <p className={styles2.newsExcerpt} dangerouslySetInnerHTML={{
                            __html: getContentExcerpt(news.content, 120),
                          }}>
                          </p>

                          <div className={styles2.newsFooter}>
                            <div className={styles2.newsActions}>
                              <Link
                                to={`/news/${news.id}`}
                                className={styles.readMore}
                              >
                                Read More <FaArrowRight />
                              </Link>
                            </div>
                          </div>
                        </div>
                      </article>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </section>
        )
      }

      {sponsorData.length > 0 && (
        <section className={`${styles.sponsorsSection} ${styles.section}`}>
          <div className={styles.container}>
            <div className={styles.sectionHeader}>
              <h2 className={styles.sectionTitle}>Our Sponsors</h2>
            </div>
            <marquee
              behavior="scroll"
              direction="left"
              scrollamount="8"
              onMouseOver={(e) => e.currentTarget.stop()}
              onMouseOut={(e) => e.currentTarget.start()}
            >
              <div className={styles.marqueeInner}>
                {sponsorData.map((sponsor, index) => (
                  <Link to={`/sponsor/${sponsor.id}`} key={index}>
                    <img
                      src={getFullImageUrl(sponsor.logo)}
                      alt={sponsor.name}
                      className={styles.marqueeImgSmall}
                      onError={(e) => (e.target.src = "/default-sponsor.png")}
                    />
                  </Link>
                ))}
              </div>
            </marquee>
          </div>
        </section>
      )}

      {
        sponsorAds.length > 0 && (
          <motion.section
            className={styles.partnerPromotion}
            initial="hidden"
            whileInView="visible"
            variants={fadeUp}
            viewport={{ once: true, amount: 0.3 }}
          >
            <div className={styles.container}>
              <div className={styles.adHeader}>
                <div className={styles.adLabel}>ADVERTISEMENT</div>
              </div>

              <div className={styles.adGrid}>
                {(() => {
                  const activeAds = sponsorAds.filter(ad => {
                    const now = new Date();
                    const start = ad.start_date ? new Date(ad.start_date) : null;
                    const end = ad.end_date ? new Date(ad.end_date) : null;

                    if (!ad.is_active) return false;
                    if (!start || !end) return false;

                    return now >= start && now <= end;
                  });

                  if (activeAds.length === 0) {
                    return (
                      <div className={styles.noActiveAds}>
                        <div className={styles.noAdsIcon}>
                          <FaBullhorn />
                        </div>
                        <h4>No Active Advertisements</h4>
                        <p>Check back later for new promotions</p>
                      </div>
                    );
                  }

                  const sortedAds = activeAds
                    .sort((a, b) => {
                      const priorityA = a.display_order || 0;
                      const priorityB = b.display_order || 0;
                      return priorityA - priorityB;
                    });

                  return sortedAds.map((ad, index) => (
                    <div key={ad.id || index} className={styles.adCard}>
                      <div className={styles.adContent}>
                        <div className={styles.adMediaContainer}>
                          {ad?.ad_type === "video" ? (
                            <video
                              className={styles.adMedia}
                              autoPlay
                              muted
                              loop
                              playsInline
                            >
                              <source
                                src={getFullImageUrl(ad?.media_file)}
                                type="video/mp4"
                              />
                            </video>
                          ) : (
                            <img
                              src={getFullImageUrl(ad?.media_file)}
                              alt={ad?.title}
                              className={styles.adMedia}
                              onError={(e) => {
                                e.target.style.display = "none";
                                const fallback =
                                  e.target.parentNode.querySelector(
                                    `.${styles.adFallback}`
                                  );
                                if (fallback) fallback.style.display = "flex";
                              }}
                            />
                          )}

                          <div className={styles.adFallback}>
                            <div className={styles.fallbackLogo}>  <FaBuilding /></div>
                            <div className={styles.fallbackText}>
                              <div className={styles.fallbackCompany}>
                                {ad?.sponsor_data?.name}
                              </div>
                            </div>
                          </div>

                          <div className={styles.adOverlay}>
                            <button
                              className={styles.adButton}
                              onClick={(e) => {
                                e.stopPropagation();
                                ad?.target_url && handleAdClick(ad);
                              }}
                            >
                              Learn More
                            </button>
                          </div>
                        </div>

                        <div className={styles.adInfo}>
                          <Link
                            to={`/advertisement-detail/${ad.id}`}
                            style={{ textDecoration: "none" }}
                          >
                            <span className={styles.adBadge}>Sponsored </span>
                            <span className={styles.adCompanyName}>
                              {" "}
                              {ad?.sponsor_data?.name} →
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  ));
                })()}
              </div>
            </div>
          </motion.section>
        )
      }
      {/* CTA Section */}
      <Subscription />
    </div >
  );
};

export default Home;
